import articlePublicationStatuses from "astrid-firestore/src/api/articles/constants/articlePublicationStatuses";

import Label from "../../../ui/components/Label/Label";

import usePublicationStatuses from "../../hooks/usePublicationStatuses";

export default function ArticleChannelPublicationStatus({ article, channel }) {
	const publicationStatuses = usePublicationStatuses();
	const status = article?.channels?.[channel?.id]?.publicationStatus;
	const publicationStatus = publicationStatuses[status || articlePublicationStatuses.NOT_PUBLISHED];

	return <Label color={publicationStatus.color}>{publicationStatus.text}</Label>;
}
